export const MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/pbct53thRPgkbawMNNqTF7/MockUp_Lb_IT.png'
